import { IFilterOptions } from "@services/QuoteBuilder/QuoteBuilderService";

export type FilterOptionsAction = {
  type: "SET_FILTER_OPTIONS";
  payload: IFilterOptions | null;
};

export function filterOptionsReducer(
  state: IFilterOptions | null,
  action: FilterOptionsAction
): IFilterOptions | null {
  switch (action.type) {
    case "SET_FILTER_OPTIONS":
      return action.payload;

    default:
      console.log(`Error - incorrect action sent ${action} ${state}`);
      return state;
  }
}
